import React from "react";
import { Logo } from "../Logo";
import { EVENT_CONFIG } from "../../config/event";
import { logAnalytics } from "../../lib/api";

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="bg-navy-950 text-white pt-20 pb-10 relative overflow-hidden">
            <div aria-hidden className="absolute inset-0 bg-grid-navy opacity-30 pointer-events-none" />
            <div className="relative max-w-[1400px] mx-auto px-5 md:px-8">
                <div className="grid md:grid-cols-3 gap-10">
                    <div>
                        <Logo variant="light" size="lg" />
                        <p className="mt-6 text-white/60 max-w-sm text-sm leading-relaxed">
                            SafetyDesk81 è un progetto di <strong className="text-white">Centro Sicurezza Consulenze</strong>: la piattaforma con chatbot AI e registri digitali per organizzare aziende, scadenze, formazione e adempimenti in un unico posto.
                        </p>
                    </div>

                    <div>
                        <div className="text-[11px] font-mono uppercase tracking-widest text-white/40 mb-4">Contatti</div>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    data-testid="footer-email"
                                    href={`mailto:${EVENT_CONFIG.EVENT_CONTACT_EMAIL}`}
                                    onClick={() => logAnalytics("email_click", { source: "footer" })}
                                    className="text-white/85 hover:text-gold-400 transition-colors"
                                >
                                    {EVENT_CONFIG.EVENT_CONTACT_EMAIL}
                                </a>
                            </li>
                            {EVENT_CONFIG.EVENT_WHATSAPP && (
                                <li>
                                    <a
                                        data-testid="footer-whatsapp"
                                        href={`https://wa.me/${EVENT_CONFIG.EVENT_WHATSAPP.replace(/\D/g, "")}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        onClick={() => logAnalytics("whatsapp_click", { source: "footer" })}
                                        className="text-white/85 hover:text-gold-400 transition-colors"
                                    >
                                        WhatsApp: {EVENT_CONFIG.EVENT_WHATSAPP}
                                    </a>
                                </li>
                            )}
                            <li>
                                <a href="/privacy" data-testid="footer-privacy" className="text-white/85 hover:text-gold-400 transition-colors">Informativa privacy</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <div className="text-[11px] font-mono uppercase tracking-widest text-white/40 mb-4">Evento</div>
                        <p className="text-white/85 text-sm leading-relaxed">
                            Presentazione ufficiale — <strong className="text-gold-400">Giovedì 1 ottobre 2026</strong>
                            <br />
                            {EVENT_CONFIG.EVENT_ADDRESS}
                            <br />
                            <span className="text-white/60">Aperitivo {EVENT_CONFIG.EVENT_APERITIVO_TIME} · Presentazione {EVENT_CONFIG.EVENT_PRESENTATION_TIME} · Cena a buffet {EVENT_CONFIG.EVENT_DINNER_TIME}</span>
                        </p>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div className="text-xs text-white/40">
                        © {year} Centro Sicurezza Consulenze · SafetyDesk81 · Tutti i diritti riservati
                    </div>
                    <div className="text-xs text-white/40">
                        <a href="/admin/login" className="hover:text-white/70 transition-colors" data-testid="footer-admin">Area amministrativa</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
